(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vdv-account-popup"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var storageKey='vdv_account_popup_seen_v1';
    function remember(){try{sessionStorage.setItem(storageKey,'1')}catch(error){}}
    function init(){
      document.querySelectorAll('[data-vdv-account-popup]').forEach(function(dialog){
        if(dialog.dataset.vdvInitialized==='true')return;
        dialog.dataset.vdvInitialized='true';
        if(window.Shopify&&window.Shopify.designMode)return;
        try{if(sessionStorage.getItem(storageKey))return}catch(error){}
        var closeButton=dialog.querySelector('[data-vdv-popup-close]');
        closeButton.addEventListener('click',function(){dialog.close()});
        dialog.addEventListener('close',remember);
        dialog.querySelectorAll('a').forEach(function(link){link.addEventListener('click',remember)});
        window.setTimeout(function(){
          if(dialog.isConnected&&!dialog.open&&typeof dialog.showModal==='function')dialog.showModal();
        },0);
      });
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
    else init();
    document.addEventListener('shopify:section:load',init);
  })();

  } catch(e) { console.error(e); }
})();
})();
